export default __webpack_public_path__ + "static/media/hht1_song_14.261b2bad.png";